import clsx from "clsx";
import { Tag } from "data/types";
import React, { useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { Card } from "./Card";
import { TagComponent } from "./TagComponent";

export interface ExploreTagsProps {
  tags: Tag[];
}

export const ExploreTags: React.FC<ExploreTagsProps> = ({ tags }) => {
  const [open, setOpen] = useState(false);

  return (
    <Card className="mb-4 p-3 py-2">
      <div className="mb-1">Explore tags:</div>
      <div
        className={clsx("mb-1.5 flex flex-wrap gap-1 overflow-hidden", {
          "max-h-[50px]": !open,
        })}
      >
        {tags.map((t) => (
          <TagComponent tag={t} key={t.name} />
        ))}
      </div>
      <div className="flex">
        <div
          onClick={() => setOpen(!open)}
          className="mx-auto flex cursor-pointer items-center gap-0.5 text-sm text-blue-600 hover:underline dark:text-blue-400"
        >
          {open ? (
            <>
              Show less <MdKeyboardArrowUp className="inline-block" />
            </>
          ) : (
            <>
              Show more
              <MdKeyboardArrowDown className="inline-block" />
            </>
          )}
        </div>
      </div>
    </Card>
  );
};
